import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { RequestAccessSettingModel } from '../request-access-setting.model';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { RequestAccessSettingService } from '../request-access-setting.service';
import { AppTextService } from '@fi-shared/app-text/app-text.service';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters/access-right-filter-settings';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import {
    AccessRightFiltersComponent,
    AccessRightFiltersSourceType,
} from '@fi-shared/access-right-filters/access-right-filters.component';
import { first } from 'rxjs/operators';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { RequestAccessSettingsAccessRightFiltersComponent } from '@fi-app/request-access-setting/access-right-filters/access-right-filters.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-request-access-setting-edit',
    templateUrl: './request-access-setting-edit.component.html',
    styleUrls: ['./request-access-setting-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-request-access-setting-edit' },
    standalone: false,
})
export class RequestAccessSettingEditComponent implements OnInit, AfterViewInit {
    @Input('requestAccessSetting') RequestAccessSetting: RequestAccessSettingModel;
    @ViewChild(RequestAccessSettingsAccessRightFiltersComponent, { static: false })
    accessRightFilters: AccessRightFiltersComponent;
    EditTabs: EditTabsModel;
    AccessRightFilterSettings: AccessRightFilterSettings;

    AccessRightFiltersSourceType = AccessRightFiltersSourceType;

    constructor(
        private fiLoadingService: LoadingService,
        private requestAccessService: RequestAccessSettingService,
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private stateService: FiStateService,
    ) {}

    ngOnInit() {
        this.EditTabs = new EditTabsModel(
            `${this.appTextService.get('common.edit')} ${this.appTextService.get('other_settings.request_access')}`,
            this.appTextService.get('common.cancel'),
        );
        this.AccessRightFilterSettings = new AccessRightFilterSettings(ModuleType.Core, false, true, ObjectTypes.User);
    }

    ngAfterViewInit(): void {
        const getModelData = () => ({
            requestAccessSetting: this.RequestAccessSetting,
        });

        this.accessRightFilters.onInitialized$.pipe(first()).subscribe(() => {
            this.saveChangesWarningService.start(getModelData);
        });
    }

    save() {
        this.fiLoadingService
            .trackPromise(this.requestAccessService.saveRequestAccessSetting(this.RequestAccessSetting))
            .then(() => {
                this.saveChangesWarningService.stop();
                this.stateService.go(FiStateNames.OtherSettings.List);
            });
    }
}
